export default __webpack_public_path__ + "static/media/MarkPro-Bold.62069f88.otf";